import { http } from "./index";

export const getOrderDetails = (data) => http.post(`order/details`, data);
